var BreadcrumbDataTestIdEnum = /* @__PURE__ */ ((BreadcrumbDataTestIdEnum2) => {
  BreadcrumbDataTestIdEnum2["BREADCRUMB_CONTAINER"] = "breadcrumb--container";
  BreadcrumbDataTestIdEnum2["BREADCRUMB_HOUSE_ICON_LINK"] = "breadcrumb--house-icon-link";
  BreadcrumbDataTestIdEnum2["BREADCRUMB_OPTION"] = "breadcrumb--option";
  return BreadcrumbDataTestIdEnum2;
})(BreadcrumbDataTestIdEnum || {});
export {
  BreadcrumbDataTestIdEnum
};
